var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 9.5c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8zM19.9 3H13c-.3 0-.6.1-.8.3l-8.9 8.9c-.2.3-.3.5-.3.8 0 .3.1.6.3.8l6.9 6.9c.4.4 1.1.4 1.5 0l8.9-8.9c.2-.2.3-.5.3-.8V4.1c.1-.6-.4-1.1-1-1.1z"
  })));
}

export default SvgTag;